import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "section"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        rootMargin: "-20% 0px -70% 0px",
        threshold: 0
      }
    )

    this.sectionTargets.forEach((section) => {
      this.observer.observe(section)
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollTo(event) {
    event.preventDefault()
    const targetId = event.currentTarget.getAttribute("href").slice(1)
    const targetSection = document.getElementById(targetId)

    if (targetSection) {
      const navHeight = this.element.querySelector("[data-scroll-nav-target='nav']")?.offsetHeight || 0
      const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - navHeight - 16

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      })

      this.setActiveLink(targetId)
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.setActiveLink(entry.target.id)
      }
    })
  }

  setActiveLink(sectionId) {
    this.linkTargets.forEach((link) => {
      const span = link.querySelector("span")
      const linkTargetId = link.getAttribute("href").slice(1)
      const isActive = linkTargetId === sectionId

      if (isActive) {
        link.classList.remove("font-normal")
        link.classList.add("font-semibold")
        if (span) {
          span.classList.remove("border-transparent", "group-hover:border-black-20")
          span.classList.add("border-black-40")
        }
      } else {
        link.classList.remove("font-semibold")
        link.classList.add("font-normal")
        if (span) {
          span.classList.remove("border-black-40")
          span.classList.add("border-transparent", "group-hover:border-black-20")
        }
      }
    })
  }
}
